'use strict';

module.exports = {
    resetFilter: function(params) {
        params = params || {};
        this.view.resetFilter(params);
    },

    onOnlyClickFilter: function(params) {
        this.rebuildWidgetIfNeeded(params.tabId);
        this.view.onOnlyClickFilter(params);
    },
};
